import React, { useState, useMemo, useEffect, useCallback } from "react";
import { Col, Row } from "react-bootstrap";
import { getAlerts } from "../utils/api";
import AlertToasts from "../components/AlertToasts";

interface useAlertsProps {
  type: "dashboard" | "ltc" | "school";
}

export default function useAlerts({ type }: useAlertsProps) {
  const [alerts, setAlerts] = useState<Data.Alert[]>([]);
  const fetchAlerts = useCallback(async () => {
    const alerts = await getAlerts();
    setAlerts(alerts.filter((alert) => alert.dashboard === type));
  }, [type]);

  useEffect(() => {
    fetchAlerts();
  }, [fetchAlerts]);

  const renderAlerts = useMemo(() => {
    return alerts.length > 0 ? (
      <Row className={`w-100 m-0 pt-4 pb-4 align-items-center`}>
        <Col md={12}>
          <AlertToasts alerts={alerts} />
        </Col>
      </Row>
    ) : null;
  }, [alerts]);

  return { renderAlerts };
}
